import { render, staticRenderFns } from "./SendResetPasswordForm.vue?vue&type=template&id=040db02e&scoped=true&"
import script from "./SendResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SendResetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./SendResetPasswordForm.vue?vue&type=style&index=0&id=040db02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040db02e",
  null
  
)

export default component.exports